import React, {useState} from 'react'
import PropTypes from 'prop-types'


const BaseRadioBtn = ({value,caption,name}) => {

    const [check, setCheck] = useState(false)
    const clName = check ? "base-radio-btn btn-checked" : "base-radio-btn"

    const handleCheckbox = (e) => {
        console.log(e.target.checked)
        setCheck(e.target.checked)
    }

    return (
    <label className={clName} htmlFor={value}>
        <input id={value} type={'radio'} name={name} value={value} checked={check} onChange={handleCheckbox}  />
        <span>{caption}</span>
    </label>
    )
}

;

BaseRadioBtn.propTypes = {
    value: PropTypes.any,
    caption: PropTypes.string,
    name: PropTypes.string,
};

export default BaseRadioBtn